import {
  beABTestGetABTestConfigById,
  beABTestGetAbTestIdByInvio
} from 'Api/beABTestApi'
import {
  beFiltersGetFilter,
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters
} from 'Api/beFiltersApi'
import { BeListApiGetList } from 'Api/BeListApi'
import {
  beMessGetDynamicContentByIdMessages,
  beMessGetMessageMinimumDetails
} from 'Api/BeMessApi'
import { bePecPlusGetPecPlusConfig } from 'Api/bePecPlusApi'
import {
  BEQUEUE_CONFIG_ACTION_MAIL,
  BEQUEUE_CONFIG_EXCLUDE,
  BEQUEUE_CONFIG_FILTER_COND_OR,
  BEQUEUE_CONFIG_INCLUDE,
  BEQUEUE_CONFIG_TYPE_EVERYBODY,
  beQueueClearEmailSendingQueue,
  beQueueGetQueuedEmailRecipients,
  beQueueGetSenderInEmailQueue,
  beQueueRemoveRecipientFromEmailSendingQueue,
  beQueueSimulateConfigurationProcessing,
  beQueueUpdateSenderInEmailQueue
} from 'Api/beQueueApi'
import { beRecipientGetGroupDetails } from 'Api/beRecipientApi'
import {
  beSendGoApiGetSmartPlanningSuggestedDate,
  beSendGoGetEmailSendingDetails,
  beSendGoGetNoDisturbConfig,
  beSendGoRemoveNoDisturbConfig,
  beSendGoSetNoDisturbConfig,
  beSendGoSetStandBySendingToReady,
  beSendGoUpdateNoDisturbConfig
} from 'Api/beSendGoApi'
import { campaignsBuilderGetEmailCampaignByIdMessage } from 'Api/campaignsBuilderApi'
import {
  FILTER_TYPE_ENGAGEMENT,
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  SENDING_SOURCE_IMMEDIATE,
  SENDING_SOURCE_SCHEDULED,
  SENDING_SOURCE_SCHEDULED_NOW,
  STORE_KEY_LOGIN_TYPE
} from 'Constants/index'
import getIntl from 'Helpers/intl'
import {
  evalCondition,
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  storeGet
} from 'mailup-react-helpers'

export const getSmartPlanningSuggestedDate = async idSending => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beSendGoApiGetSmartPlanningSuggestedDate(idList, idSending)
  return result
}

export async function getNoDisturbConfig(idSending) {
  const result = beSendGoGetNoDisturbConfig(idSending)

  return result
}

export async function setNoDisturbConfig(idSending, value) {
  const result = beSendGoSetNoDisturbConfig(idSending, value)
  return result
}

export async function updateNoDisturbConfig(idSending, value) {
  const result = beSendGoUpdateNoDisturbConfig(idSending, value)
  return result
}

export async function removeNoDisturbConfig(idSending) {
  const result = beSendGoRemoveNoDisturbConfig(idSending)
  return result
}

export const getMessageDetails = async idMessage => {
  const result = await beMessGetMessageMinimumDetails(idMessage)

  return { title: result.Subject || undefined }
}

export const getCampaignsInfo = async idMessage => {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const result = await campaignsBuilderGetEmailCampaignByIdMessage(
    idMessage,
    idList
  )

  return result
}

export const getTotalSendingTime = async (idSending, idMessage) => {
  const queueResults = await beSendGoGetEmailSendingDetails(idSending)
  const { Size: msgSize } = await beMessGetMessageMinimumDetails(idMessage)
  const dynamicContents = await beMessGetDynamicContentByIdMessages([idMessage])
  if (!queueResults) {
    return { EstimatedTime: 0, Queued: 0 }
  }

  let dynamicContentsSize = 0
  if (dynamicContents.Items.length > 0) {
    const getMessageContents = dynamicContents.Items[0].Contents
    getMessageContents.forEach(content => {
      dynamicContentsSize += content.Size
    })
  }

  const { Bandwidth, IsSendMethodTypeFrequency } = storeGet(STORE_KEY_ACCOUNT)
  const { Queued } = queueResults
  let estimatedTime = 0

  if (IsSendMethodTypeFrequency) {
    estimatedTime = Math.ceil((Queued / Bandwidth) * 60)
  } else {
    estimatedTime =
      ((msgSize + dynamicContentsSize) * Queued) / (1024 * Bandwidth)
  }

  return { EstimatedTime: estimatedTime, Queued }
}

export const getEmailSendingDetails = async idSending => {
  const result = await beSendGoGetEmailSendingDetails(idSending)
  return result
}

export const getSenderInEmailQueue = async idSending => {
  const result = await beQueueGetSenderInEmailQueue(idSending)
  return result && result.Items.length > 0 && result.Items[0]
}

export const updateSenderInEmailQueue = async (
  idSending,
  newName,
  newEmail,
  oldName,
  oldEmail
) => {
  const data = {
    OldSender: {
      Name: oldName,
      Email: oldEmail
    },
    NewSender: {
      Name: newName,
      Email: newEmail
    }
  }
  await beQueueUpdateSenderInEmailQueue(idSending, data)
}

export async function getPecPlusGetPecPlusConfig() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await bePecPlusGetPecPlusConfig(idList)
  const getList = await BeListApiGetList(idList)

  return { pecConfig: result, listName: getList.Name || undefined }
}

export async function getAbTestIdByInvio(idSending) {
  const res = beABTestGetAbTestIdByInvio(idSending)
  return res
}

export async function getQueuedEmailRecipients(idSending, params) {
  const res = beQueueGetQueuedEmailRecipients(idSending, params)
  return res
}

export async function scheduleNow(idSending) {
  const { IdList } = await beSendGoGetEmailSendingDetails(idSending)
  const { TimeZoneCode } = await BeListApiGetList(IdList)

  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: new Date().toISOString(),
    TimeZoneInternalCode: TimeZoneCode,
    Source: SENDING_SOURCE_SCHEDULED_NOW
  })
}

export async function setSendingImmediate(idSending) {
  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: null,
    TimeZoneInternalCode: '',
    Source: SENDING_SOURCE_IMMEDIATE
  })
}

export async function setSendingScheduled(
  idSending,
  DateStart,
  timeZone,
  planningType
) {
  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: DateStart.toISOString(),
    TimeZoneInternalCode: timeZone,
    Source: SENDING_SOURCE_SCHEDULED,
    PlanningType: planningType
  })
}

export async function removeRecipientFromEmailSendingQueue(
  idSending,
  idRecipient
) {
  const res = beQueueRemoveRecipientFromEmailSendingQueue(
    idSending,
    idRecipient
  )
  return res
}

export async function clearEmailSendingQueue(idSending) {
  const res = beQueueClearEmailSendingQueue(idSending)
  return res
}

export async function simulateSending(
  idSending,
  groups,
  excludedGroups,
  filters
) {
  const { IdList } = await beSendGoGetEmailSendingDetails(idSending)

  const config = {
    IdList,
    IdInvio: 0,
    Action: BEQUEUE_CONFIG_ACTION_MAIL,
    Type: BEQUEUE_CONFIG_TYPE_EVERYBODY,
    FiltersConditionRule: BEQUEUE_CONFIG_FILTER_COND_OR,
    AsyncQueueFilter: filters.map(({ id: IdFilter }) => ({ IdFilter })),
    AsyncQueueGroup: [
      ...groups.map(({ id: IdGroup }) => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_INCLUDE
      })),
      ...excludedGroups.map(({ id: IdGroup }) => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_EXCLUDE
      }))
    ]
  }

  const result = await beQueueSimulateConfigurationProcessing(config)

  return result
}

export async function getGroupById(idGroup) {
  const result = await beRecipientGetGroupDetails(idGroup)
  return result ? makeGroupItem(result) : null
}

const makeGroupItem = ({ Id, Name }) => ({
  name: `${Id} - ${Name}`,
  id: Id
})

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const allFilters = (
    await beFiltersGetListOfFilters(idList, {
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false,
      hidden
    })
  ).Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export async function getSegmentationDetails(
  Groups,
  ExcludeGroups,
  Filtri,
  IdSendStop
) {
  const hasEngagement = evalCondition('co:DELSTATS OR co:ENGAGEMENT')
  const hasSimulation = evalCondition('co:DELTACALCSEGM')

  const groupsIds = Groups.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const groupsCalls = groupsIds
    .filter(id => id !== 0) // escludo il nogroups, lo controllo dopo
    .map(idGroup => {
      return idGroup !== -1
        ? beRecipientGetGroupDetails(idGroup)
        : {
            Id: idGroup
          }
    })

  const groups = (await Promise.all(groupsCalls)).map((group, index) => {
    return group
      ? {
          id: group.Id,
          name: group.Name
        }
      : {
          id: groupsIds[index],
          deleted: true
        }
  })
  // controllo il noGroups
  groupsIds.includes(0) &&
    groups.push({
      id: 0,
      name: getIntl().formatMessage({ id: 'Load.Filters.NoGroupOption' })
    })

  const excludedGroupsIds = ExcludeGroups.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const excludedGroupsCalls = excludedGroupsIds.map(idGroup =>
    beRecipientGetGroupDetails(idGroup)
  )

  const excludedGroups = (await Promise.all(excludedGroupsCalls)).map(
    (group, index) => {
      return group
        ? {
            id: group.Id,
            name: group.Name
          }
        : {
            id: excludedGroupsIds[index],
            deleted: true
          }
    }
  )

  const filtersIds = Filtri.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const filtersCalls = filtersIds.map(idFilter => beFiltersGetFilter(idFilter))

  const filters = (await Promise.all(filtersCalls))
    .map((filter, index) => {
      return filter
        ? {
            id: filter.Id,
            name: filter.Name,
            type: filter.Type
          }
        : {
            id: filtersIds[index],
            deleted: true
          }
    })
    .filter(({ type }) => {
      return type !== FILTER_TYPE_ENGAGEMENT || hasEngagement
    })

  const anyDeleted = []
    .concat(groups, excludedGroups, filters)
    .some(o => !!o.deleted)

  return {
    groups,
    excludedGroups,
    filters,
    simulationEnabled: hasSimulation && IdSendStop === 0 && !anyDeleted
  }
}

export async function getABTestConfigByIdAction(idABTest) {
  const ret = await beABTestGetABTestConfigById(idABTest)
  return ret
}
